import React from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const NewMandatory = () => {
    // General Information Data
    const generalInfoData = [
        { no: 1, info: 'NAME OF THE SCHOOL', details: 'DREAM INDIA SCHOOL' },
        { no: 2, info: 'AFFILIATION NO.(IF APPLICABLE)', details: '-' },
        { no: 3, info: 'SCHOOL CODE (IF APPLICABLE)', details: '-' },
        { no: 4, info: 'Address', details: 'D.NO.27-13-2 RAJUPETA, TIRUVURU MANDAL, NEAR ASHTHA LAKSHMI TEMPLE, NTR, ANDHRA PRADESH – 521235' },
        { no: 5, info: 'PRINCIPAL NAME', details: 'Shhabana Panjabi' },
        { no: 6, info: 'PRINCIPAL QUALIFICATION', details: ' MA, BEd' },
        { no: 7, info: 'SCHOOL EMAIL ID', details: 'info.tiruvuru@dreamindia.com' },
        { no: 8, info: 'CONTACT DETAILS (LANDLINE/MOBILE)', details: '8886421212, 8886521212' }
    ];

    const generalInfoColumns = [
        { field: 'no', header: '#', headerStyle: { width: '5%' } },
        { field: 'info', header: 'INFORMATION' },
        { field: 'details', header: 'DETAILS' }
    ];

    // Documents and Information Data
    const documentsData = [
        { no: 1, doc: 'COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY', link: '#' },
        { no: 2, doc: 'COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE', link: 'https://dreamindia.com/documents/DI_Education_Society_Registration_Certificate.pdf' },
        { no: 3, doc: 'COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT', link: 'https://dreamindia.com/documents/State_Noc.pdf' },
        { no: 4, doc: 'COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT\'S RENEWAL IF APPLICABLE', link: 'https://dreamindia.com/documents/Affiliation_I_X_Copy.pdf' },
        { no: 5, doc: 'COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE', link: 'https://dreamindia.com/documents/Annexure_D_Building_Safety_Certificate.pdf' },
        { no: 6, doc: 'COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY', link: 'https://dreamindia.com/documents/FireSafety.pdf' },
        { no: 7, doc: 'COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATION OR SELF CERTIFICATION BY SCHOOL', link: 'https://dreamindia.com/documents/Self_Certificates.pdf' },
        { no: 8, doc: 'COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES', link: 'https://dreamindia.com/documents/Annexure_C_Drinking_Water_and_Sanitary_Condition.pdf' },
        { no: 9, doc: 'COPIES OF LAND CERTIFICATE', link: 'https://dreamindia.com/documents/Land_Certificate_N.pdf' }
    ];

    const documentsColumns = [
        { field: 'no', header: '#', headerStyle: { width: '5%' } },
        { field: 'doc', header: 'DOCUMENTS/INFORMATION' },
        {
            field: 'link',
            header: 'UPLOAD DOCUMENTS',
            body: (rowData) => (
                <a href={rowData.link} target="_blank" rel="noopener noreferrer" className="p-button p-component p-button-text p-button-plain document-link">
                    View
                </a>
            ),
            headerStyle: { width: '15%' }
        }
    ];

    // Results and Academics Data
    const resultsAcademicsData = [
        { no: 1, doc: 'FEE STRUCTURE', link: 'https://dreamindia.com/documents/Fee_Structure_DIS_Signed.pdf' },
        { no: 2, doc: 'Annual Academic Calendar', link: 'https://dreamindia.com/documents/DIS_Academic_Calendar_2025_2026_Signed.pdf' },
        { no: 3, doc: 'SMC - LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)', link: 'https://dreamindia.com/documents/SMC.pdf' },
        { no: 4, doc: 'PTA - LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS', link: 'https://dreamindia.com/documents/PTA_DIS.pdf' },
        { no: 5, doc: 'LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABLILITY', link: '-' }
    ];

    const resultsAcademicsColumns = [
        { field: 'no', header: '#', headerStyle: { width: '5%' } },
        { field: 'doc', header: 'DOCUMENTS/INFORMATION' },
        {
            field: 'link',
            header: 'UPLOAD DOCUMENTS',
            body: (rowData) => (
                rowData.link === '-' ? 
                '-' : 
                <a href={rowData.link} target="_blank" rel="noopener noreferrer" className="p-button p-component p-button-text p-button-plain document-link">
                    View
                </a>
            ),
            headerStyle: { width: '15%' }
        }
    ];

    // Staff Teaching Data
const staffData = [
    { no: 1, info: 'Principal', details: 'Shhabana Panjabi' },
    { no: 2, info: 'Total No. of Teachers', details: '22' },
    { no: '', info: '– PRT', details: '7' },
    { no: '', info: '– TGT', details: '10' },
    { no: '', info: '– Librarian', details: '1' },
    { no: '', info: '– PET', details: '1' },
    { no: '', info: '– Special Educator', details: '1' },
    { no: '', info: '– School Counselor', details: '1' },
    { no: '', info: '– Music and Dance', details: '1' },
    { no: 3, info: 'Teachers–Section Ratio', details: '1:30' },
    { no: 4, info: 'Details of Special Educator', details: 'Mansi Kaul' },
    { no: 5, info: 'Details of Counselor', details: 'Kopal Shrivastav' }
];

    const staffColumns = [
        { field: 'no', header: 'S. No.', headerStyle: { width: '10%' } },
        { field: 'info', header: 'Information' },
        { field: 'details', header: 'Details', bodyStyle: { textAlign: 'center' } }
    ];

    // Class X Results Data (empty rows)
    const classXData = [
        { no: '', year: '', registered: '', passed: '', percentage: '', remarks: '' },
        { no: '', year: '', registered: '', passed: '', percentage: '', remarks: '' },
        { no: '', year: '', registered: '', passed: '', percentage: '', remarks: '' }
    ];

    const classXColumns = [
        { field: 'no', header: 'S. No.', headerStyle: { width: '10%' } },
        { field: 'year', header: 'Year', headerStyle: { width: '15%' } },
        { field: 'registered', header: 'No. of Registered Students', headerStyle: { width: '20%' } },
        { field: 'passed', header: 'No. of Students Passed', headerStyle: { width: '20%' } },
        { field: 'percentage', header: 'Pass Percentage', headerStyle: { width: '15%' } },
        { field: 'remarks', header: 'Remarks' }
    ];

    // Class XII Results Data (empty rows)
    const classXIIColumns = classXColumns; // Same structure

    // School Infrastructure Data
    const infrastructureData = [
        { no: 1, info: 'Total campus area of the school', details: '8,093 sq. m' },
        { no: 2, info: 'Number and size of classrooms (in sq. m)', details: '19 | 50' },
        { no: 3, info: 'Number and size of laboratories (incl. computer labs, in sq. m)', details: '3 | 57' },
        { no: 4, info: 'Internet facility', details: 'Yes' },
        { no: 5, info: 'Number of girls\' toilets', details: '15' },
        { no: 6, info: 'Number of boys\' toilets', details: '27' },
        { no: 7, info: 'Link to YouTube video showing school inspection and infrastructure', details: '-' }
    ];

    const infrastructureColumns = [
        { field: 'no', header: 'S. No.', headerStyle: { width: '10%' } },
        { field: 'info', header: 'Information' },
        { field: 'details', header: 'Details', bodyStyle: { textAlign: 'center' } }
    ];

    const mandatoryDisclosureHeader = <h2 className="m-0 text-white">Mandatory Disclosure</h2>;

    const generalHeader = <h2 className="m-0 text-white"><span className="highlight">GENERAL</span> INFORMATION</h2>;

    const documentsHeader = <h2 className="m-0 text-white">DOCUMENTS<span className="highlight"> AND</span> INFORMATION</h2>;

    const resultsHeader = <h2 className="m-0 text-white">RESULTS <span className="highlight">AND</span> ACADEMICS</h2>;

    const staffHeader = <h2 className="m-0 text-white">STAFF <span className="highlight">(TEACHING)</span></h2>;

    const classXHeader = <h2 className="m-0 text-white">RESULT CLASS: <span className="highlight">X</span></h2>;

    const classXIIHeader = <h2 className="m-0 text-white">RESULT CLASS: <span className="highlight">XII</span></h2>;

    const infrastructureHeader = <h2 className="m-0 text-white">SCHOOL: <span className="highlight">INFRASTRUCTURE</span></h2>;

    return (
        <div className="p-8">
            <div className="flex flex-column gap-3 max-w-1200 mx-auto">
                {/* Mandatory Disclosure Section */}
                {/* <Card className="section-card px-8" header={mandatoryDisclosureHeader}>
                    <div className="pdf-container w-full  border-round border-1 surface-border" style={{height:'45rem'}}>
                        <iframe
                            src="https://dreamindia.com/documents/DIS_Mandatory_Disclosure_Details.pdf"
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            className="border-none border-round"
                            title="Mandatory Disclosure PDF"
                        >
                            <p>Your browser does not support PDFs. <a href="https://dreamindia.com/documents/DIS_Mandatory_Disclosure_Details.pdf" target="_blank" rel="noopener noreferrer">Download the PDF</a>.</p>
                        </iframe>
                    </div>
                </Card> */}

                {/* General Information Section */}
                <Card className="section-card" header={generalHeader}>
                    <DataTable value={generalInfoData} stripedRows responsiveLayout="scroll" className="w-full">
                        {generalInfoColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>

                {/* Documents and Information Section */}
                <Card className="section-card" header={documentsHeader}>
                    <DataTable value={documentsData} stripedRows responsiveLayout="scroll" className="w-full">
                        {documentsColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>

                {/* Results and Academics Section */}
                <Card className="section-card" header={resultsHeader}>
                    <DataTable value={resultsAcademicsData} stripedRows responsiveLayout="scroll" className="w-full">
                        {resultsAcademicsColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>

                {/* Teaching Staff Section */}
                <Card className="section-card" header={staffHeader}>
                    <DataTable value={staffData} stripedRows responsiveLayout="scroll" className="w-full">
                        {staffColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>

                {/* Class X Results Section */}
                <Card className="section-card" header={classXHeader}>
                    <DataTable value={classXData} stripedRows responsiveLayout="scroll" className="w-full">
                        {classXColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>

                {/* Class XII Results Section */}
                <Card className="section-card" header={classXIIHeader}>
                    <DataTable value={classXData} stripedRows responsiveLayout="scroll" className="w-full">
                        {classXIIColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>

                {/* School Infrastructure Section */}
                <Card className="section-card" header={infrastructureHeader}>
                    <DataTable value={infrastructureData} stripedRows responsiveLayout="scroll" className="w-full">
                        {infrastructureColumns.map((col, i) => <Column key={i} {...col} />)}
                    </DataTable>
                </Card>
            </div>
        </div>
    );
};

export default NewMandatory;